import { render, staticRenderFns } from "./editorSelectionToolPopover.vue?vue&type=template&id=96e0d200&"
import script from "./editorSelectionToolPopover.vue?vue&type=script&lang=js&"
export * from "./editorSelectionToolPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports